import axios from "../../utils/axios";

// 品牌管理
export function getList(query) {
    return axios({
        url: "brandManage/getList",
        method: "get",
        params: query
    });
}
//品牌删除
export function deleteBrand(data) {
    return axios({
        url: "brandManage/delete",
        headers:{'content-type': "application/x-www-form-urlencoded"},
        method: "post",
        data: data
    });
}
// 品牌增加
export function addBrand(data) {
    return axios({
        url: "brandManage/update",
        method: "post",
        data: data
    });
}

// 品牌修改
export function updateBrand(data) {
    return axios({
        url: "brandManage/update",
        method: "post",
        data: data
    });
}
//标签列表

// 品牌修改
export function getUserSearchList(query) {
    return axios({
        url: "mbUserSearch/getList",
        method: "get",
        params: query
    });
}
//添加/修改
export function add(data) {
    return axios({
        url: "mbUserSearch/add",
        method: "post",
        data: data
    });
}
//删除标签
export function deleteSearch(data) {
    return axios({
        url: "mbUserSearch/delete",
        method: "post",
        data: data
    });
}
